<template>
  <div>
    <edit-role-popup
      :data-to-show="isPopupRoleDisplayed"
      @showChange="
        (val) => {
          changeStateEditRolePopup(val);
        }
      "
      :is-new-role="isNewRole"
    />
    <delete-role-popup
      :data-to-show="popupDeleteState"
      @showChange="
        (val) => {
          changeStateDeleteRolePopup(val);
        }
      "
    />

    <!-- BEGIN Button to add a "Rôle" -->
    <add-button
      v-if="$can(constants.PERMISSION_GESTION_DROITS_ROLE_AJOUTER)"
      libelle="Ajouter un rôle"
      @add="displayEditRolePopup()"
      class="my-10 mx-5 lg:mx-15 2xl:mx-20"
    />
    <!-- END Button to add a "Rôle" -->

    <list-grid
      :list-items="adminRoles.concat(managerRoles)"
    >
      <template #header>
        <div class="col-span-6 md:col-span-3 ml-5 md:ml-10">
          Rôles
        </div>
        <div class="col-span-5 hidden lg:inline-block">
          Descriptions
        </div>
        <div class="col-span-4 md:col-span-2">
          Droits d'accès
        </div>
        <div class="col-span-2 hidden sm:inline-block text-center mr-5 md:mr-10">
          Suppression
        </div>
      </template>

      <template #accordionDescription="{ item }">
        <div
          class="col-span-6 md:col-span-3 ml-5 md:ml-10 place-self-center justify-self-start text-lg truncate w-full"
        >
          {{ item.name }}
        </div>
        <div
          class="col-span-5 hidden lg:inline-block place-self-center justify-self-start text-base text-gray-600"
        >
          {{ item.description }}
        </div>
        <div
          class="col-span-4 md:col-span-2 place-self-center lg:justify-self-start justify-self-center"
        >
          <div
            class="inline-flex items-center justify-center xxl:justify-start w-full group border border-transparent text-sm leading-4 rounded-md focus:outline-none transition ease-in-out duration-150"
            v-if="
              $can(constants.PERMISSION_GESTION_DROITS_ROLE_EDITER) &&
                item.type === constants.ROLE_TYPE_MANAGER
            "
          >
            <action-button
              border-color="border-transparent"
              text-color="text-gray-900"
              bg-color="bg-indigo-300"
              bg-color-square="bg-indigo-200"
              icon-color="text-indigo-600"
              libelle="Droits d'accès"
              :responsive="true"
              icon="edit"
              text-size="sm"
              @clickAction="displayEditRolePopup(item)"
            />
          </div>
        </div>
        <div
          class="col-span-2 justify-self-center lg:justify-self-start place-self-center mr-5 md:mr-10"
          title="Supprimer le rôle"
        >
          <circle-button
            v-if="
              $can(constants.PERMISSION_GESTION_DROITS_ROLE_SUPPRIMER) &&
                item.type === constants.ROLE_TYPE_MANAGER
            "
            icon="close"
            label="Supprimer le rôle"
            icon-scale="75"
            @buttonClick="displayConfirmDeletePopup(item)"
          />
        </div>
      </template>
    </list-grid>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Icon from './../../components/Icon';

import AddButton from './../../components/Inputs/AddButton.vue';
import CircleButton from './../../components/CircleButton';
import ActionButton from './../../components/ActionButton';
import ListGrid from './../../components/AccordionTable/ListGrid.vue';

import EditRolePopup from './popup/EditRole';
import DeleteRolePopup from './popup/DeleteRole';

import Constants from './../../constants';

export default {
  components: {
    Icon,
    AddButton,
    CircleButton,
    ActionButton,
    EditRolePopup,
    DeleteRolePopup,
    ListGrid,
  },
  name: 'Roles',

  data() {
    return {
      popupDeleteState: -1,
      isPopupRoleDisplayed: false,
      newEmptyRole: {},

      constants: Constants,
    };
  },

  async mounted() {
    await this.initEmptyRole();
  },

  methods: {
    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_ROLETOEDIT: 'roles/SET_ROLETOEDIT',
      SET_ISNEWROLE: 'roles/SET_ISNEWROLE',
    }),

    ...mapActions({}),

    initEmptyRole() {
      console.log('wait...initialize empty role');

      this.newEmptyRole = {
        id: null,
        name: '',
        description: '',
        rights: {
          neopassForm: {
            read: { all: false },
            edit: { all: false },
          },
        },
      };

      //Prepare data structure for neopass form permissions
      this.listNeopassModulesPages.forEach((mod) => {
        this.newEmptyRole.rights.neopassForm.read[mod.name] = { all: false };
        this.newEmptyRole.rights.neopassForm.edit[mod.name] = { all: false };

        mod.pages.forEach((page) => {
          this.newEmptyRole.rights.neopassForm.read[mod.name][
            page.name
          ] = false;
          this.newEmptyRole.rights.neopassForm.edit[mod.name][
            page.name
          ] = false;
        });
      });

      //Prepare data structure for others modules permissions
      this.listPermissions
        .filter((p) => p.type == 'page')
        .forEach((mod) => {
          //initialize group module in rights
          this.newEmptyRole.rights[mod.module] = {};
          this.listPermissions
            .filter((p2) => p2.type == 'function' && p2.module == mod.module)
            .forEach((func) => {
              this.newEmptyRole.rights[mod.module][func.name] = false;
            });
        });
    },

    initStatus() {
      setTimeout(() => {
        this.SET_ROLETOEDIT({});
      }, 200);
      this.SET_SAVING(false);
      this.SET_ERRORS(null);
    },

    changeStateEditRolePopup(state) {
      this.isPopupRoleDisplayed = state;
      if (!state) {
        this.initStatus();
      }
    },

    displayEditRolePopup(role = null) {
      this.isPopupRoleDisplayed = true;

      if (role == null) {
        this.SET_ROLETOEDIT(this.newEmptyRole);
        this.SET_ISNEWROLE(true);
      } else {
        let loadedRole = {};
        loadedRole.id = role.id;
        loadedRole.typeAction = 'edit';
        this.SET_ROLETOEDIT(loadedRole);
        this.SET_ISNEWROLE(false);
      }
    },

    changeStateDeleteRolePopup(state) {
      this.popupDeleteState = state;
      if (state < 0) {
        this.initStatus();
      }
    },

    displayConfirmDeletePopup(role) {
      let loadedRole = role;
      loadedRole.typeAction = 'delete';
      this.SET_ROLETOEDIT(loadedRole);

      this.changeStateDeleteRolePopup(1);
    },
  },

  computed: {
    ...mapGetters({
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      listPermissions: 'permissions/listPermissions',
      allowed: 'app/allowed',
      messageHeader: 'permissions/messageHeader',
      roles: 'roles/roles',
      roleToEdit: 'roles/roleToEdit',
      isNewRole: 'roles/isNewRole',
    }),

    adminRoles() {
      return this.roles.filter((role) => role.type === this.constants.ROLE_TYPE_ADMIN);
    },

    managerRoles() {
      return this.roles.filter((role) => role.type === this.constants.ROLE_TYPE_MANAGER);
    },
  },
};
</script>
